// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2W3XS","upload":"Small_upload__1wB4x","imageWrap":"Small_imageWrap__c9mBC","removeBtn":"Small_removeBtn__32pJ-"};